import { LitElement, html, css } from 'lit';
import {msg,str} from '@lit/localize';
import { validateForm,validatePassword,gRecaptcha, validationHandler, validationHandlerClear,hideRevealPassword} from '../../utilities/formsUtilities';
import { accessibility,formStyles } from '../../utilities/styles';
import { eyeSvg } from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
export class AllInResetPasswordForm extends LitElement {
    static properties = {
        action: { type: String },
        nonce: { type: String },
        alreadyLoggedInMessage: { type: String },
        loggedIn: { type: String},
        passwordReset: { type: Boolean },
        retry: { type: String },
        hardlinks: { type: Object },
        _code: { state: true, type: String },
        _errorMessage: { state: true, type: String },
        _resetSuccess: { state: true, type: String },
        _resetError: { state: true, type: String },

    }

    constructor() {
        super();
        this.eventManager = new EventManager(this);
        setTimeout(()=>{
            this.eventManager.emit('allin-login', {loggedOut: true});
        }, 100);
        document.cookie = "allin-uid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
        this.loggedIn = 'false';
        this._resetSuccess = false;
        this._errorMessage = '';
        let queryString = window.location.search;
        let params = new URLSearchParams(queryString);
        this.token = params.get('token_hash');
        if(this.token){
            this._code = this.token;
            this._hashType = 'token_hash';
        }
        else{
            let codeHash = window.location.hash;
            if(codeHash) {
                let code = codeHash.substring(1);
                if(code.includes('access_token')){
                    let params = new URLSearchParams(code);
                    this._code = params.get('access_token');
                    this._hashType = 'access_token';
                }
                else if(code.includes('error')){
                    if( code_message.includes('otp_expired')){
                    this._resetError=msg(html`<p>The link you followed has expired.</p>
                    <p>If you weren't expecting this link to be expired, please contact your IT department to check if this domain (https://allin.online) is in the allowlist.</p>
                    <p><a href="${this.hardlinks['verify_your_email']}">Please request a new one</a></p>`);
                    }
                    else{
                        let params = new URLSearchParams(code);
                        this._resetError = params.get('error_description') || msg('An error occurred while resetting your password. Please try again later.',{desc:'Error message for password reset failure'});
                    }
                    this._code = false;
                }

            }
        }
    }

    get form() {
        return this.shadowRoot.querySelector('form');
    }

    get formResponse() {
        return this.shadowRoot.querySelector('.message');
    }

    get submitButton() {
        return this.shadowRoot.querySelector('input[type="submit"]');
    }

    render() {
        let markup;
        if(this.loggedIn=='true') {
            markup = html`
                <p>${this.alreadyLoggedInMessage}</p>
            `
        }
        else if (this._resetError) {
            markup = html`
                <div class="error">
                    <h3>${msg('Error resetting password',{desc:'Error message for password reset failure'})}</h3>
                    <p>${this._resetError}</p>
                    <p><a href="${this.retry}">${msg('Retry',{desc:'Button to retry password reset'})}</a></p>
                </div>
            `
        }
        else if(this.passwordReset && this._code) {
            markup = html`
                <form action="${this.action}-new" method="post" @submit=${this._reset}>
                    <div class="form_inner ${this._resetSuccess?'hide':''}" >
                        <div class="message notice" aria-live="polite"></div>
                         <div class="input-group">
                            <label for="password">${msg('New password',{desc:'label for password input field'})}*</label>
                            <div class="pword_wrapper">
                                <input type="password" name="password" id="password" aria-required @change=${this._onPasswordChange}>
                                <button data-switch="password" aria-label="${msg('Show password')}" aria-pressed="false" type="button" class="show-password" @click=${hideRevealPassword}>
                                ${eyeSvg}${msg('Show password')}</button>
                            </div>
                        </div>
                        <div class="input-group">
                            <label for="password_confirm">${msg('Confirm password')}*</label>   
                            <div class="pword_wrapper">
                                <input type="password" name="password_confirm" id="password_confirm" aria-required @change=${this._onPasswordConfirmChange}>
                                <button data-switch="password_confirm" aria-label="${msg('Show password')}" aria-pressed="false" type="button" class="show-password" @click=${hideRevealPassword}>
                               ${eyeSvg} ${msg('Show password')}</button>
                            </div>
                        </div>
                        <input type="hidden" name="code" value="${this._code}">
                        <input type="hidden" name="hash_type" value="${this._hashType}">
                        <input type="text" name="login" id="login" class="hp" autocomplete="off">
                        <input type="submit" value="${msg('Submit')}">
                    </div>
                    <div class="notice" aria-live="assertive">
                        <div class="${this._errorMessage?'':'hide'} error">${this._errorMessage}</div>
                        <slot name="success-message" class="${this._resetSuccess?'':'hide'} success"></slot>
                    </div>
                </form>
            `
        }
        else if (this.passwordReset){
            window.location.href = '/login';
        }
        else{
            markup = html`
                <form action="${this.action}" method="post" @submit=${this._reset}>
                    <div class="form_inner ${this._resetSuccess?'hide':''}" >
                        <div class="message notice" aria-live="polite"></div>
                        <div class="input-group">
                            <label for="email">${msg('Enter your email to reset your password')}</label>
                            <input type="email" name="email" id="email" placeholder="${msg('Email')}" aria-required>
                        </div>
                        <input type="text" name="login" id="login" class="hp" autocomplete="off">
                        <input type="submit" value="${msg('Submit')}">
                    </div>
                    <div class="notice" aria-live="assertive">
                        <div class="${this._errorMessage?'':'hide'} error">${this._errorMessage}</div>
                        <slot name="success-message-email" class="${this._resetSuccess?'':'hide'} success"></slot>
                    </div>
                </form>
                
            `
        }
        return html` 
            <div class="reset-form">
                <slot name="reset-form-header"></slot>
                ${markup}
            </div>
        `
    }

    async _reset(e) {
        e.preventDefault();
        this.formResponse.innerHTML = '';
        this.formResponse.classList.remove('error');
        let valid = validateForm(this.form,this.formResponse);
        if(!valid) return;
        let formData = new FormData(this.form);
        
        formData = JSON.stringify(Object.fromEntries(formData));
        this.form.classList.add('loading');
        this.submitButton.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        
        let gTokenValid  = await gRecaptcha(this.formResponse,this.action,this.nonce); 
        if(!gTokenValid){
            this.form.classList.remove('loading');
            this.form.setAttribute('aria-busy', 'false');
            this.submitButton.disabled = false;
            return;
        }
        try{
            let response = await fetch(this.action, {
                method: 'POST',
                body: formData,
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Reset': 'reset',
                }
            })
            response = await response.json();
            if(response.ok){
                this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                this._resetSuccess = true;
                this.formResponse.innerHTML = response.message?response.message: msg('Password reset successful. You can now log in with your new password.',{desc:'Message for successful password reset'});
                if(response.redirect){
                    window.location.href = response.redirect;
                }
            }
            else{
                this.formResponse.innerHTML = response.message;
                this.formResponse.classList.add('error');
                this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                this.submitButton.disabled = false;
            }
        }
        catch(error){
            console.error('Error:', error);
        }
    }

    _onPasswordChange(e){
        e.preventDefault();
        let passwordField = e.target;
        let form = passwordField.closest('form');
        let submitButton = form.querySelector('input[type="submit"]');
        validationHandlerClear(passwordField );
        let valid = validatePassword(passwordField.value);
        if(valid!==true){
            let error_message = valid.join('<br>');
            validationHandler(passwordField,error_message);   
            submitButton.disabled = true;
        }
        let passwordConfirmField = form.querySelector('#password_confirm');
        if(passwordConfirmField.value){
            if(passwordField.value!==passwordConfirmField.value){
                valid=false;
                validationHandler(passwordConfirmField,msg(str`Passwords do not match`));
                submitButton.disabled = true;
            }
            else{
                validationHandlerClear(passwordConfirmField);
            }
        }
        if(valid){
            submitButton.disabled = false;
        }
    }

    _onPasswordConfirmChange(e){
        e.preventDefault();
        let passwordConfirmField = e.target;
        let form = passwordConfirmField.closest('form');
        let submitButton = form.querySelector('input[type="submit"]');
        validationHandlerClear(passwordConfirmField);
        let passwordField = form.querySelector('#password');
        if(passwordField.value!==passwordConfirmField.value){
            validationHandler(passwordConfirmField,msg(str`Passwords do not match`));
            submitButton.disabled = true;
        }
        else{
            validationHandlerClear(passwordConfirmField);
            submitButton.disabled = false;
        }
    }

    static styles = [
        accessibility,
        formStyles,
        css`
            .reset-form{
                background-color:var(--allin-bg-color,transparent);
                padding:var(--allin-padding,2rem);
                width:680px;
                max-width:85vw;
                margin:0 auto;
            }

        `
    ]
}


